var View = require('views/base/view');
import TimerPage from './decorators/TimerPage';
import BasicTimer from './basic-timer';
import TimerSession from './decorators/TimerSession';

// this is the client, it will take the parameters and compose the corresponding decorator.
var TimerView = View.extend({
    template: require('./templates/timer'),
    autoRender: true,

    initialize: function () {
        let countdown, context;

        if (this.model) {
            // these properties are attached via the page-view.js line 220
            countdown = this.model.get('countdown');
            context = this.model.get('context');
        }

        if (((!countdown || countdown === 0)  && context === "page") || (countdown > 0 && context === "page")) {
            // countdown/countup page level decorator
            this.basicTimer = new BasicTimer(new TimerPage(countdown));
        }

        if (((!countdown || countdown === 0)  && context === "session") || (countdown > 0 && context === "session")) {
            // countdown/countup session level decorator
            this.basicTimer = new BasicTimer(new TimerSession(countdown));
        }
    },

    getTemplateFunction: function () {
        return this.template;
    },

    render: function () {
        if (this.basicTimer) 
            this.basicTimer.getTimerInstance().startTimer();
        /* This is an example to show the timer when reaches 0, it enables a button, it will be removed. */
        Chaplin.mediator.subscribe('timer:done', function() {
            $('#someId').html('Enabled');
            $('#someId').removeClass('disabled');
        });
        View.prototype.render.apply(this, arguments);
    },

    dispose: function() {
        if (this.basicTimer && this.basicTimer.getTimerInstance()) {
            this.basicTimer.getTimerInstance().dispose();
        }
    }
});

module.exports = TimerView;